module.exports = __webpack_public_path__ + "favicon-16x16.4fe6e8eb.png";